import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withKeys as _withKeys, vShow as _vShow, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "fixed inset-0 z-[200] flex items-center justify-end overflow-hidden vue-modal-background tw at-update-rate-group"
};
const _hoisted_2 = {
  class: "bg-white w-1/2 p-6 space-y-4 border border-l h-full"
};
const _hoisted_3 = {
  class: "flex justify-between"
};
const _hoisted_4 = {
  key: 0,
  class: "flex w-full justify-between"
};
const _hoisted_5 = {
  class: "text-lg font-semibold"
};
const _hoisted_6 = {
  class: "text-green-regular"
};
const _hoisted_7 = {
  class: "w-3/12"
};
const _hoisted_8 = {
  class: "flex justify-between mt-1 at-name"
};
const _hoisted_9 = {
  class: "w-1/2 pr-4"
};
const _hoisted_10 = {
  class: "w-1/2 pl-4 at-description"
};
const _hoisted_11 = {
  class: "border-b border-gray-200"
};
const _hoisted_12 = {
  class: "overflow-y-auto absolute top-60 bottom-20 w-1/2"
};
const _hoisted_13 = {
  class: "inline-block print:inline py-2 min-w-full align-middle"
};
const _hoisted_14 = {
  class: "bar-border-bottom border-gray-200 shadow"
};
const _hoisted_15 = {
  class: "min-w-full divide-y divide-gray-200 at-rate-group-table"
};
const _hoisted_16 = ["data-cy", "aria-sort", "onClick", "onKeydown"];
const _hoisted_17 = {
  class: "bg-white divide-y divide-gray-200"
};
const _hoisted_18 = {
  "data-cy": "rate-group-user-name",
  class: "py-3 px-6 whitespace-nowrap print:whitespace-normal print:px-1"
};
const _hoisted_19 = {
  class: "py-3 px-6 whitespace-nowrap print:whitespace-normal print:px-1"
};
const _hoisted_20 = {
  class: "py-3 px-6 whitespace-nowrap print:whitespace-normal print:px-1 number-input input-prepend"
};
const _hoisted_21 = ["onUpdate:modelValue"];
const _hoisted_22 = {
  class: "inline-block print:inline py-2 min-w-full align-middle"
};
const _hoisted_23 = {
  class: "bar-border-bottom border-gray-200 shadow"
};
const _hoisted_24 = {
  class: "min-w-full divide-y divide-gray-200"
};
const _hoisted_25 = ["data-cy", "aria-sort", "onClick", "onKeydown"];
const _hoisted_26 = {
  class: "bg-white divide-y divide-gray-200"
};
const _hoisted_27 = {
  class: "py-3 px-6 whitespace-nowrap print:whitespace-normal print:px-1"
};
const _hoisted_28 = {
  class: "py-3 px-6 whitespace-nowrap print:whitespace-normal print:px-1"
};
const _hoisted_29 = {
  class: "py-3 px-6 whitespace-nowrap print:whitespace-normal print:px-1"
};
const _hoisted_30 = {
  "data-cy": "rate-group-matter-name",
  class: "py-3 px-6 whitespace-nowrap print:whitespace-normal print:px-1"
};
const _hoisted_31 = {
  class: "bottom-0 right-10 absolute px-6 py-4 pr-16 at-save-update-btn h-20"
};
import { computed, reactive, onMounted, ref } from 'vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import { useAccountsStore } from '@/services/UserService/useAccountsStore';
import { useRateGroupStore } from '@/services/useRateGroupStore';
import { clearModalHack } from '@/services/utils';
import ListsService from '@/services/ListsService';
import LlConfirmationDialog from '@/components/LlConfirmationDialog.vue';
import LlIcon from '@/components/LlIcon.vue';
import LlTabs from '@/components/LlTabs.vue';
export default {
  __name: 'UpdateRateGroupModal',
  props: {
    rateGroupState: {
      type: Object,
      required: true
    },
    alerts: {
      type: Object,
      required: true
    },
    modalService: {
      type: Object,
      required: true
    }
  },
  emits: ['rateGroupUpdated'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const listsService = new ListsService();
    const editRateGroupState = reactive({
      accounts: [],
      loading: false,
      matters: [],
      name: '',
      description: '',
      default: false,
      rateGroupId: null,
      rateGroup: {},
      matterTab: true,
      rateGroupAccounts: [],
      rateGroupMatters: [],
      rateGroupAction: [{
        name: 'Delete',
        value: 'delete'
      }, {
        name: 'Duplicate',
        value: 'duplicate'
      }, {
        name: 'Set as default',
        value: 'setDefault'
      }],
      showZeroRateConfirmationModal: false,
      saveWithZeroRate: false
    });
    const selectedAction = ref({
      name: 'Select Action',
      value: ''
    });
    const accountsStore = useAccountsStore();
    const rateGroupStore = useRateGroupStore();
    accountsStore.alerts = props.alerts;
    const emits = __emit;
    const zeroRateAlert = ref(undefined);
    const userColumns = [{
      key: 'name',
      label: 'Name'
    }, {
      key: 'role',
      label: 'Role'
    }, {
      key: 'rate',
      label: 'Rate ($/hr)'
    }];
    const matterColumns = [{
      key: 'clientReference',
      label: 'Client ID'
    }, {
      key: 'client',
      label: 'Client'
    }, {
      key: 'reference',
      label: 'Matter ID'
    }, {
      key: 'name',
      label: 'Matter'
    }];
    const userSort = reactive({
      key: 'name',
      desc: false
    });
    const matterSort = reactive({
      key: 'name',
      desc: false
    });
    const userSortValues = {
      name: a => a.name,
      role: a => roleDescription(a),
      rate: a => Number(a.rate) || 0
    };
    const matterSortValues = {
      clientReference: m => m.client?.referenceSort ?? m.client?.reference,
      client: m => m.client?.name,
      reference: m => m.referenceSort ?? m.reference,
      name: m => m.name
    };
    const compareValues = (a, b) => typeof a === 'number' && typeof b === 'number' ? a - b : String(a ?? '').localeCompare(String(b ?? ''), undefined, {
      sensitivity: 'base',
      numeric: true
    });

    // Sorted on demand rather than via computed so rows don't jump while a rate is being edited.
    const sortRows = (rows, sort, values) => {
      const value = values[sort.key];
      const direction = sort.desc ? -1 : 1;
      return [...rows].sort((a, b) => direction * compareValues(value(a), value(b)));
    };
    const toggleSort = (sort, key) => {
      sort.desc = sort.key === key ? !sort.desc : false;
      sort.key = key;
    };
    const ariaSort = (sort, key) => {
      if (sort.key !== key) return 'none';
      return sort.desc ? 'descending' : 'ascending';
    };
    const sortUsers = key => {
      toggleSort(userSort, key);
      editRateGroupState.rateGroupAccounts = sortRows(editRateGroupState.rateGroupAccounts, userSort, userSortValues);
    };
    const sortMatters = key => {
      toggleSort(matterSort, key);
      editRateGroupState.rateGroupMatters = sortRows(editRateGroupState.rateGroupMatters, matterSort, matterSortValues);
    };
    onMounted(async () => {
      editRateGroupState.loading = true;
      if (props.rateGroupState.rateGroupId) {
        const accounts = props.rateGroupState.rateGroupAccounts;
        editRateGroupState.rateGroupAccounts = props.rateGroupState.rateGroupList;
        editRateGroupState.name = props.rateGroupState.name;
        editRateGroupState.description = props.rateGroupState.description;
        editRateGroupState.default = props.rateGroupState.default;
        editRateGroupState.rateGroupId = props.rateGroupState.rateGroupId;
        editRateGroupState.rateGroupAccounts = mapAccountsToRateGroupAccounts(accounts);
      } else {
        const accounts = await accountsStore.listAccounts();
        editRateGroupState.rateGroupAccounts = mapToCreateRateGroupAccounts(accounts);
      }
      editRateGroupState.rateGroupAccounts = sortRows(editRateGroupState.rateGroupAccounts, userSort, userSortValues);
      editRateGroupState.loading = false;
    });
    const closeModal = () => {
      props.rateGroupState.openEditRateGroupModal = false;
      props.rateGroupState.rateGroupId = null;
    };
    const createRateGroup = async id => {
      if (!editRateGroupState.name) {
        props.alerts.error('Please enter a name');
        return;
      }
      if (!editRateGroupState.description) {
        props.alerts.error('Please enter a description');
        return;
      }
      const hasZeroRate = editRateGroupState.rateGroupAccounts.some(item => item.rate === 0);
      if (hasZeroRate && !editRateGroupState.saveWithZeroRate) {
        triggerZeroRateConfirmation(id);
        return;
      }
      if (id) {
        showRateChangeEntryModal();
        return;
      }
      await rateGroupStore.createRateGroup({
        name: editRateGroupState.name,
        description: editRateGroupState.description,
        rateGroupAccounts: editRateGroupState.rateGroupAccounts
      });
      closeModal();
    };
    const showRateChangeEntryModal = async () => {
      const confirm = props.modalService.showModal({
        template: require('@/modules/modals/rateChange/template.html'),
        inputs: {
          onlyUpdateEntryOptions: true
        },
        bodyClass: 'show-modal-overlay',
        controller: 'RateChangeModalController'
      }).then(modal => {
        modal.element.modal();
        return modal.close.then(async result => {
          clearModalHack();
          if (!result) return;
          const rateOptions = {
            updateEntries: result.updateEntries
          };
          await updateRateGroup(rateOptions);
        });
      }, e => console.error('Rate update modal rejected:', e));
      await confirm;
    };
    const updateRateGroup = async rateOptions => {
      const updateParams = {
        name: editRateGroupState.name,
        description: editRateGroupState.description,
        rateGroupAccounts: editRateGroupState.rateGroupAccounts,
        rateOptions
      };
      await rateGroupStore.updateRateGroup(props.rateGroupState.rateGroupId, updateParams);
      emits('rateGroupUpdated');
      closeModal();
    };
    const mapAccountsToRateGroupAccounts = accounts => {
      return accounts.map(a => ({
        accountId: a.accountId,
        rate: a.rate,
        name: a.accountName,
        role: a.role
      }));
    };
    const mapToCreateRateGroupAccounts = accounts => {
      return accounts.map(a => ({
        accountId: a.id,
        rate: a.rate,
        name: a.name,
        role: a.role
      }));
    };
    const roleDescription = user => {
      return listsService.userRoles.find(r => r.id === user.role)?.label || '';
    };
    const changeAction = async selectedValue => {
      selectedAction.value = selectedValue;
      if (selectedValue.value === 'delete') {
        // Check if rate group is in use
        // if its in use, show error message
        const rateGroup = props.rateGroupState.rateGroupList?.find(item => item.rateGroupId === props.rateGroupState?.rateGroupId);
        if (rateGroup?.mattersCount > 0) {
          props.alerts.error("Cannot delete a rate group while it's in use.");
          return;
        }
        await rateGroupStore.deleteRateGroup(props.rateGroupState.rateGroupId);
        closeModal();
      } else if (selectedValue.value === 'duplicate') {
        await rateGroupStore.duplicateRateGroup(props.rateGroupState.rateGroupId);
        closeModal();
      } else if (selectedValue.value === 'setDefault') {
        editRateGroupState.default = true;
        rateGroupStore.updateRateGroup(props.rateGroupState.rateGroupId, editRateGroupState);
        rateGroupStore.rateGroupList = rateGroupStore.rateGroupList.map(item => {
          if (item.id === props.rateGroupState.rateGroupId) {
            item.default = true;
          } else {
            item.default = false;
          }
          return item;
        });
        closeModal();
      }
    };

    // Matters only exists once the rate group has been saved.
    const rateGroupTabs = computed(() => [{
      value: 'users',
      label: 'Users',
      dataCy: 'rate-group-tab-users'
    }, ...(editRateGroupState.rateGroupId ? [{
      value: 'matters',
      label: 'Matters',
      dataCy: 'rate-group-tab-matters'
    }] : [])]);

    // `matterTab` is true on the Users tab. Matters loads its list on every click, so
    // re-clicking it refreshes the list; that's why this listens to `select`.
    const selectRateGroupTab = tab => {
      if (tab === 'matters') loadGroupMatters();else editRateGroupState.matterTab = true;
    };
    const loadGroupMatters = async () => {
      editRateGroupState.matterTab = false;
      editRateGroupState.loading = true;
      editRateGroupState.rateGroupMatters = sortRows((await rateGroupStore.loadGroupMatters(editRateGroupState.rateGroupId)) ?? [], matterSort, matterSortValues);
      editRateGroupState.loading = false;
    };
    const triggerZeroRateConfirmation = id => {
      editRateGroupState.showZeroRateConfirmationModal = true;
      zeroRateAlert.value.open().then(async result => {
        if (result) {
          editRateGroupState.showZeroRateConfirmationModal = false;
          editRateGroupState.saveWithZeroRate = true;
          createRateGroup(id);
        } else {
          editRateGroupState.showZeroRateConfirmationModal = false;
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_v_select = _resolveComponent("v-select");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(LlConfirmationDialog, {
        showWarningIcon: true,
        ref_key: "zeroRateAlert",
        ref: zeroRateAlert,
        title: "",
        "confirm-text": "Save Anyway",
        "toggle-text": "Cancel",
        message: `Note: $0 default rates are not recommended. A user's default rate will be assigned unless another rate is specified. Therefore, a $0 default rate can result in time entries becoming ready to bill or even sent in invoices with $0 rates.`
      }, null, 512), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[8] || (_cache[8] = _createElementVNode("span", {
        class: "text-xs"
      }, "Rate Group", -1)), (_openBlock(), _createElementBlock("svg", {
        onClick: _cache[0] || (_cache[0] = $event => closeModal()),
        width: "14",
        height: "14",
        class: "close-btn cursor-pointer",
        viewBox: "0 0 16 16",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }, [...(_cache[7] || (_cache[7] = [_createElementVNode("g", {
        transform: "translate(2.000000, 2.000000)",
        stroke: "#727272"
      }, [_createElementVNode("path", {
        d: "M0.24,0.24 L11.76,11.76",
        "stroke-width": "2"
      }), _createElementVNode("path", {
        d: "M0.24,0.24 L11.76,11.76",
        "stroke-width": "2",
        transform: "translate(6.000000, 6.000000) scale(-1, 1) translate(-6.000000, -6.000000) "
      })], -1)]))]))]), props.rateGroupState.rateGroupId ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, [_createTextVNode(_toDisplayString(editRateGroupState.name) + " ", 1), _createElementVNode("span", _hoisted_6, _toDisplayString(editRateGroupState.default ? '(Default)' : ''), 1)]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_v_select, {
        modelValue: selectedAction.value,
        "onUpdate:modelValue": [_cache[1] || (_cache[1] = $event => selectedAction.value = $event), _cache[2] || (_cache[2] = $event => changeAction($event))],
        items: editRateGroupState.rateGroupAction,
        "item-title": "name",
        "item-value": "value",
        density: "compact",
        "return-object": "",
        variant: "outlined"
      }, null, 8, ["modelValue", "items"])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_cache[9] || (_cache[9] = _createElementVNode("label", {
        for: "name",
        class: "ml-1"
      }, "Name", -1)), _withDirectives(_createElementVNode("input", {
        name: "name",
        type: "text",
        class: "rounded-border w-full",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => editRateGroupState.name = $event)
      }, null, 512), [[_vModelText, editRateGroupState.name]])]), _createElementVNode("div", _hoisted_10, [_cache[10] || (_cache[10] = _createElementVNode("label", {
        for: "name",
        class: "ml-1"
      }, "Description", -1)), _withDirectives(_createElementVNode("input", {
        name: "description",
        type: "text",
        class: "rounded-border w-full",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => editRateGroupState.description = $event)
      }, null, 512), [[_vModelText, editRateGroupState.description]])])]), _createElementVNode("div", _hoisted_11, [_createVNode(LlTabs, {
        "model-value": editRateGroupState.matterTab ? 'users' : 'matters',
        items: rateGroupTabs.value,
        onSelect: selectRateGroupTab
      }, null, 8, ["model-value", "items"])]), _createElementVNode("div", _hoisted_12, [_withDirectives(_createElementVNode("div", null, [_createElementVNode("div", _hoisted_13, [_withDirectives(_createElementVNode("div", _hoisted_14, [_createElementVNode("table", _hoisted_15, [_createElementVNode("thead", null, [_createElementVNode("tr", null, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(userColumns, col => {
        return _createElementVNode("th", {
          key: col.key,
          "data-cy": `rate-group-user-sort-${col.key}`,
          scope: "col",
          tabindex: "0",
          "aria-sort": ariaSort(userSort, col.key),
          class: "sticky top-0 py-4 px-6 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50 cursor-pointer select-none",
          onClick: $event => sortUsers(col.key),
          onKeydown: _withKeys($event => sortUsers(col.key), ["enter"])
        }, [_createTextVNode(_toDisplayString(col.label) + " ", 1), userSort.key === col.key ? (_openBlock(), _createBlock(LlIcon, {
          key: 0,
          icon: userSort.desc ? 'mdi-arrow-down' : 'mdi-arrow-up',
          size: "x-small"
        }, null, 8, ["icon"])) : _createCommentVNode("", true)], 40, _hoisted_16);
      }), 64))])]), _createElementVNode("tbody", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editRateGroupState.rateGroupAccounts, account => {
        return _openBlock(), _createElementBlock("tr", {
          key: account.id
        }, [_createElementVNode("td", _hoisted_18, _toDisplayString(account.name), 1), _createElementVNode("td", _hoisted_19, _toDisplayString(roleDescription(account)), 1), _createElementVNode("td", _hoisted_20, [_withDirectives(_createElementVNode("input", {
          name: "rate",
          type: "number",
          "onUpdate:modelValue": $event => account.rate = $event,
          class: "rounded-border"
        }, null, 8, _hoisted_21), [[_vModelText, account.rate]])])]);
      }), 128))])])], 512), [[_vShow, editRateGroupState.rateGroupAccounts.length > 0 || editRateGroupState.loading]])])], 512), [[_vShow, editRateGroupState.matterTab]]), _withDirectives(_createElementVNode("div", null, [_createElementVNode("div", _hoisted_22, [_withDirectives(_createElementVNode("div", null, " Not associated with any matters ", 512), [[_vShow, !editRateGroupState.rateGroupMatters.length && !editRateGroupState.loading]]), _withDirectives(_createElementVNode("div", _hoisted_23, [_createElementVNode("table", _hoisted_24, [_createElementVNode("thead", null, [_createElementVNode("tr", null, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(matterColumns, col => {
        return _createElementVNode("th", {
          key: col.key,
          "data-cy": `rate-group-matter-sort-${col.key}`,
          scope: "col",
          tabindex: "0",
          "aria-sort": ariaSort(matterSort, col.key),
          class: "sticky top-0 py-4 px-6 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50 cursor-pointer select-none",
          onClick: $event => sortMatters(col.key),
          onKeydown: _withKeys($event => sortMatters(col.key), ["enter"])
        }, [_createTextVNode(_toDisplayString(col.label) + " ", 1), matterSort.key === col.key ? (_openBlock(), _createBlock(LlIcon, {
          key: 0,
          icon: matterSort.desc ? 'mdi-arrow-down' : 'mdi-arrow-up',
          size: "x-small"
        }, null, 8, ["icon"])) : _createCommentVNode("", true)], 40, _hoisted_25);
      }), 64))])]), _createElementVNode("tbody", _hoisted_26, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editRateGroupState.rateGroupMatters, matter => {
        return _openBlock(), _createElementBlock("tr", {
          key: matter.id
        }, [_createElementVNode("td", _hoisted_27, _toDisplayString(matter.client?.reference), 1), _createElementVNode("td", _hoisted_28, _toDisplayString(matter.client?.name), 1), _createElementVNode("td", _hoisted_29, _toDisplayString(matter.reference), 1), _createElementVNode("td", _hoisted_30, _toDisplayString(matter.name), 1)]);
      }), 128))])])], 512), [[_vShow, editRateGroupState.rateGroupMatters.length > 0]])])], 512), [[_vShow, !editRateGroupState.matterTab]])]), _createElementVNode("div", _hoisted_31, [_createVNode(LlSecondaryButton, {
        class: "mr-2",
        onClick: _cache[5] || (_cache[5] = $event => closeModal())
      }, {
        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode(" Cancel ", -1)]))]),
        _: 1
      }), _createVNode(LlSecondaryButton, {
        color: "primary",
        onClick: _cache[6] || (_cache[6] = $event => createRateGroup(props.rateGroupState.rateGroupId))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(!props.rateGroupState.rateGroupId ? 'Save' : 'Update'), 1)]),
        _: 1
      })])])])], 64);
    };
  }
};